import { render, staticRenderFns } from "./PdpBonusOffer.vue?vue&type=template&id=605d448d&scoped=true&"
import script from "./PdpBonusOffer.vue?vue&type=script&lang=js&"
export * from "./PdpBonusOffer.vue?vue&type=script&lang=js&"
import style0 from "./PdpBonusOffer.vue?vue&type=style&index=0&id=605d448d&prod&lang=postcss&scoped=true&"
import style1 from "./PdpBonusOffer.vue?vue&type=style&index=1&id=605d448d&prod&lang=postcss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "605d448d",
  null
  
)

export default component.exports